// ─────────────────────────────────────────────
// SIGHT WORDS BY GRADE LEVEL
// Based on Dolch, Fry, and academic vocabulary lists.
// Each grade has words appropriate for that reading
// level, with full alphabet coverage.
// ─────────────────────────────────────────────

export const SIGHT_WORDS = {

  // ── Kindergarten ───────────────────────────
  // Complete Dolch Pre-Primer + Primer lists
  K: [
    // A
    "a", "all", "am", "an", "and", "are", "at", "away",
    // B
    "be", "big", "black", "blue", "brown",
    // C
    "can", "came", "come",
    // D
    "day", "did", "do", "down",
    // E
    "eat",
    // F
    "find", "for", "four", "funny",
    // G
    "get", "go", "good",
    // H
    "has", "have", "he", "help", "here",
    // I
    "I", "in", "is", "it",
    // J
    "jump",
    // K
    "kind",
    // L
    "like", "little", "look",
    // M
    "make", "me", "my",
    // N
    "new", "no", "not", "now",
    // O
    "on", "one", "our", "out",
    // P
    "play", "please", "pretty",
    // R
    "ran", "red", "ride", "run",
    // S
    "said", "see", "she", "so", "some",
    // T
    "the", "they", "this", "three", "to", "too", "two",
    // U
    "up", "us",
    // W
    "want", "was", "we", "went", "what", "where", "white", "who", "will", "with",
    // Y
    "yes", "yellow", "you",
    // Z
    "zero",
  ],

  // ── 1st Grade ──────────────────────────────
  // Dolch First Grade + early Fry words
  "1st": [
    // A
    "after", "again", "also", "always", "an", "any", "as", "ask",
    // B
    "back", "ball", "because", "been", "before", "best", "both", "bring", "by",
    // C
    "call", "carry", "clean", "cold", "could", "cut",
    // D
    "does", "done", "draw", "drink", "drop",
    // E
    "each", "else", "every",
    // F
    "fall", "far", "fast", "first", "five", "fly", "found", "from", "full",
    // G
    "gave", "give", "going", "green", "grow",
    // H
    "had", "hard", "him", "his", "hold", "hot", "how", "hurt",
    // I
    "if", "into",
    // J
    "just",
    // K
    "keep", "know",
    // L
    "last", "laugh", "left", "let", "light", "live", "long",
    // M
    "many", "may", "more", "much", "myself",
    // N
    "never", "next",
    // O
    "of", "off", "old", "once", "only", "open", "or", "other", "over", "own",
    // P
    "pick", "pull", "put",
    // R
    "read", "right", "round",
    // S
    "seven", "shall", "show", "sing", "sit", "six", "sleep", "small", "start", "stop",
    // T
    "take", "tell", "ten", "thank", "them", "then", "think", "those", "today", "together", "try",
    // U
    "under", "upon", "use",
    // V
    "very",
    // W
    "walk", "warm", "wash", "were", "which", "why", "wish", "work", "would", "write",
    // Y
    "your",
  ],

  // ── 2nd Grade ──────────────────────────────
  // Fry words 201-400 + grade-level sight words
  "2nd": [
    // A
    "above", "across", "add", "age", "air", "almost", "along", "already", "animals", "another",
    // B
    "began", "being", "below", "between", "body", "book", "boy",
    // C
    "came", "change", "children", "city", "close", "come", "coming", "country",
    // D
    "different", "don't", "door",
    // E
    "early", "earth", "enough", "even", "eye",
    // F
    "face", "family", "father", "feet", "fire", "food", "form",
    // G
    "girl", "got", "ground", "group",
    // H
    "hand", "head", "hear", "high", "home", "horse", "house",
    // I
    "idea", "important",
    // J
    "just",
    // K
    "kind",
    // L
    "land", "large", "later", "learn", "leave", "letter", "life", "line", "list",
    // M
    "might", "mile", "miss", "money", "morning", "mother", "move", "music",
    // N
    "name", "need", "night", "nothing", "number",
    // O
    "often", "order",
    // P
    "page", "paper", "part", "people", "place", "plant", "point", "problem",
    // Q
    "question", "quickly",
    // R
    "really", "river", "road", "room",
    // S
    "school", "sea", "second", "seem", "side", "since", "something", "soon", "still", "story", "study", "sun",
    // T
    "things", "thought", "time", "together", "tree", "turned",
    // U
    "until", "usually",
    // V
    "voice",
    // W
    "watch", "water", "while", "white", "whole", "word", "world",
    // Y
    "year", "young",
  ],

  // ── 3rd Grade ──────────────────────────────
  // Fry words 401-600 + grade-level vocabulary
  "3rd": [
    // A
    "able", "about", "adventure", "ago", "agree", "answer", "anyway",
    // B
    "beautiful", "become", "better", "business",
    // C
    "certain", "character", "children", "circle", "class", "common", "complete", "course",
    // D
    "decide", "describe", "direction", "discover",
    // E
    "effect", "either", "example", "except", "explain",
    // F
    "famous", "favorite", "follow", "free", "friend", "front",
    // G
    "game", "general", "government",
    // H
    "happen", "happy", "heard", "heart", "help", "history",
    // I
    "include", "inside", "instead",
    // J
    "join",
    // K
    "knew",
    // L
    "language", "laugh", "lead", "listen",
    // M
    "matter", "measure", "meet", "mind", "minute", "month",
    // N
    "north", "notice",
    // O
    "often", "once", "outside",
    // P
    "paragraph", "pattern", "perhaps", "picture", "plants", "popular", "possible", "product",
    // Q
    "quite",
    // R
    "reach", "reason", "remember", "repeat", "return",
    // S
    "sentence", "several", "similar", "simple", "since", "south", "special", "stand", "subject", "surprise",
    // T
    "table", "teacher", "themselves", "through", "toward", "travel",
    // U
    "understand",
    // V
    "various",
    // W
    "weather", "weight", "whether", "without", "wrote",
    // Z
    "zero",
  ],

  // ── 4th Grade ──────────────────────────────
  // Fry words 601-800 + content-area vocabulary
  "4th": [
    // A
    "accurate", "achieve", "action", "addition", "address", "affect", "afford", "allow", "amount", "ancient",
    // B
    "balance", "base", "battle", "beneath", "beyond", "blame", "border",
    // C
    "capital", "capture", "cause", "chapter", "choose", "claim", "collect", "colony", "combine", "compare", "complex", "concern", "connect",
    // D
    "damage", "debate", "declare", "defend", "define", "demand", "deposit", "detail", "develop", "difference",
    // E
    "economy", "element", "energy", "entire", "equal", "escape", "event", "evidence", "examine", "exist",
    // F
    "factor", "feature", "final", "focus", "force", "foreign",
    // G
    "gather", "global",
    // H
    "habitat", "handle",
    // I
    "identify", "ignore", "imagine", "improve", "increase", "independent", "indicate", "individual", "industry", "influence",
    // J
    "journey", "judge", "justice",
    // K
    "knowledge",
    // L
    "layer", "legend", "locate",
    // M
    "major", "method", "military", "mixture", "model", "movement", "multiple",
    // N
    "natural", "negative", "normal",
    // O
    "observe", "obtain", "occur", "opposite", "organize",
    // P
    "passage", "period", "physical", "position", "positive", "predict", "prepare", "prevent", "primary", "process", "protect", "provide", "purpose",
    // Q
    "quantity",
    // R
    "record", "reduce", "region", "relate", "release", "remove", "require", "resource", "respond", "result",
    // S
    "section", "select", "sequence", "settle", "signal", "significant", "solution", "source", "spread", "statement", "structure", "support", "survive", "symbol",
    // T
    "technology", "theory", "therefore", "throughout", "topic", "tradition", "transfer",
    // U
    "unique", "unite",
    // V
    "value", "variety", "version",
    // W
    "whole",
  ],

  // ── 5th Grade ──────────────────────────────
  // Fry words 801-1000 + upper elementary academic vocabulary
  "5th": [
    // A
    "abolish", "absorb", "abstract", "access", "accumulate", "adapt", "adequate", "adjacent", "adjust", "advance",
    // B
    "behalf", "benefit", "bias",
    // C
    "capacity", "category", "challenge", "characteristic", "circumstance", "cite", "clarify", "classify", "collaborate", "comment", "commit", "communicate", "component", "comprehend", "conclude", "conflict", "consequence", "consider", "consist", "construct", "context", "contrast", "contribute", "controversy", "convert",
    // D
    "decade", "deduce", "delegate", "demonstrate", "derive", "design", "determine", "devote", "distinct", "distribute", "document", "dominate",
    // E
    "elaborate", "eliminate", "emerge", "emphasize", "enable", "encounter", "enforce", "establish", "evaluate", "evolve", "exclude", "expand", "expose",
    // F
    "facilitate", "flexible", "foundation", "framework", "function",
    // G
    "generate", "genuine",
    // H
    "hypothesis",
    // I
    "illustrate", "implement", "imply", "impose", "interpret", "investigate",
    // J
    "justify",
    // L
    "label", "logical",
    // M
    "maintain", "manipulate", "modify", "monitor",
    // N
    "negotiate", "notion",
    // O
    "objective", "outline", "overcome",
    // P
    "perceive", "perspective", "phase", "predict", "principle", "produce", "promote",
    // Q
    "qualify",
    // R
    "recognize", "reinforce", "relevant", "reliable", "represent", "resolve", "restrict", "review",
    // S
    "schedule", "scope", "strategy", "sufficient", "summarize", "sustain",
    // T
    "technique", "tension", "transform",
    // U
    "undermine",
    // V
    "vary", "verify",
    // W
    "widespread",
  ],

  // ── 6th Grade ──────────────────────────────
  // Middle school academic vocabulary
  "6th": [
    // A
    "abandon", "abbreviate", "accelerate", "acclaim", "accomplish", "acknowledge", "acquire", "adamant", "address", "adequate",
    "advocate", "affirm", "aggravate", "agile", "alleviate", "allocate", "allusion", "ambiguous", "amend", "amplify",
    // B
    "belittle", "beneficial", "betray", "boundary", "boycott",
    // C
    "captivate", "caution", "cease", "challenge", "channel", "chorus", "circumference", "coherent", "coincide", "condemn",
    "confront", "consensus", "contemplate", "contradict", "convince", "correspond", "credible", "critique", "crucial",
    // D
    "dedicate", "defiance", "deliberate", "depict", "derive", "deviate", "dilemma", "diminish", "disrupt", "diverse",
    // E
    "effective", "emphasize", "encounter", "endure", "enforce", "enhance", "enormous", "ensure", "equality", "essential",
    // F
    "factor", "falter", "flexible", "fluctuate", "forbid", "formulate", "fragile", "frequently",
    // G
    "generate", "genuine", "grapple", "gravity", "guarantee",
    // H
    "hesitate", "hostile", "hypocrite",
    // I
    "identical", "ignorance", "illuminate", "impact", "implicit", "impose", "impression", "impulse", "inevitable", "infer",
    "inherit", "initiative", "innovate", "insist", "inspire", "integrate", "intense",
    // J
    "jeopardize", "justify",
    // K
    "keen",
    // L
    "legitimate", "literal", "logical",
    // M
    "manipulate", "mediate", "merit", "minimal", "motivate", "mutual",
    // N
    "narrate", "neutral", "notable",
    // O
    "objective", "obligation", "oppose", "optimistic",
    // P
    "perceive", "persist", "perspective", "persuade", "precise", "predominant", "prejudice", "prevail", "prioritize", "promote",
    // Q
    "qualify", "query",
    // R
    "rationalize", "refute", "reinforce", "relevant", "reluctant", "resolve", "restrain", "reveal",
    // S
    "sacrifice", "scrutinize", "significant", "simulate", "skeptical", "speculate", "stereotype", "stimulate", "substantial", "subtle",
    // T
    "tolerate", "transform", "transparent", "trespass",
    // U
    "undermine", "unify",
    // V
    "validate", "versatile", "vivid",
    // W
    "withstand",
    // Z
    "zealous",
  ],

  // ── 7th Grade ──────────────────────────────
  // Upper middle school / early high school vocabulary
  "7th": [
    // A
    "abridge", "abrupt", "abstain", "abundant", "accentuate", "adhere", "adjacent", "admonish", "adverse", "affluent",
    "aggregate", "allegiance", "allude", "altruistic", "ambivalent", "analogous", "anarchy", "anecdote", "antagonist", "anticipate",
    // B
    "benevolent", "blatant", "brittle", "bureaucracy",
    // C
    "callous", "candid", "capricious", "catalyst", "chronic", "circumvent", "coerce", "cohesive", "collateral", "compelling",
    "complacent", "comply", "concede", "condemn", "connotation", "contempt", "contend", "contraband", "controversy", "conviction",
    // D
    "deceit", "decisive", "deduce", "deficient", "delegate", "denounce", "deplete", "derive", "desolate", "detrimental",
    "devious", "diffuse", "diligent", "discord", "disdain", "disparity", "distort", "diverge", "dominate",
    // E
    "eloquent", "empower", "erode", "evasive", "evolve", "exaggerate", "excel", "exclude", "explicit", "exploit",
    // F
    "fallacy", "fanatic", "flaw", "flourish", "foil", "forsake", "foreshadow", "forthright", "frivolous", "futile",
    // G
    "gaudy", "genuine", "grievance",
    // H
    "hamper", "harbinger", "hardy", "harsh", "havoc", "hierarchy",
    // I
    "imminent", "impartial", "impede", "imperious", "implement", "imply", "incentive", "incite", "indifferent", "indulge",
    "infamous", "infer", "inflict", "ingenuity", "injustice", "innate", "instigate", "integrity",
    // J
    "jargon",
    // K
    "knowledgeable",
    // L
    "latent", "lax", "lenient", "lethal",
    // M
    "meager", "melancholy", "methodical", "meticulous", "militant", "mitigate", "modest", "monotonous",
    // N
    "negligent", "notorious",
    // O
    "obscure", "obstinate", "ominous", "oppressive",
    // P
    "paradox", "partisan", "passive", "patronize", "peculiar", "peril", "perpetuate", "plausible", "portray", "pragmatic",
    "precaution", "prevalent", "proficient", "prohibit", "prominent", "provoke",
    // Q
    "quandary",
    // R
    "radical", "rationalize", "retaliate", "rhetoric", "rigorous",
    // S
    "sanctuary", "sarcasm", "satirize", "segregate", "serene", "shrewd", "solidarity", "sovereignty", "sparse", "spontaneous",
    "stagnant", "subjective", "suppress", "susceptible", "suspicious", "sustain",
    // T
    "tenacious", "tentative", "theoretical", "toxic", "treacherous", "trivial", "turmoil",
    // U
    "unanimous", "undermine", "unjust", "unravel",
    // V
    "vague", "valid", "vanquish", "vigilant", "vindicate", "volatile",
    // W
    "wary", "weary", "wield",
    // Z
    "zealot",
  ],

  // ── 8th Grade ──────────────────────────────
  // High school preparatory vocabulary
  "8th": [
    // A
    "aberrant", "abhor", "abolish", "abrasive", "abstain", "absurd", "accelerate", "accolade", "acrimony", "adamant",
    "adept", "adroit", "aesthetic", "affable", "aggravate", "alienate", "allude", "altruism", "ameliorate", "amiable",
    "anachronism", "anecdote", "antagonize", "apathy", "appease", "archaic", "ardent", "arrogant", "articulate", "astute",
    // B
    "beguile", "belligerent", "benign", "bias", "blatant", "brazen",
    // C
    "callous", "candid", "catalyst", "caustic", "censure", "charlatan", "chronic", "circumspect", "coerce", "compel",
    "complicit", "condescend", "confiscate", "confront", "contemptuous", "contrite", "convict", "copious", "credulous", "cryptic",
    // D
    "debase", "debris", "deceive", "decorum", "defame", "deliberate", "delude", "denounce", "deprave", "despondent",
    "devious", "diatribe", "diffident", "diligent", "discern", "disparage", "dogmatic", "dubious",
    // E
    "eccentric", "egregious", "elusive", "empathy", "enigmatic", "erratic", "erudite", "euphemism", "exacerbate", "exonerate",
    // F
    "fallacious", "fastidious", "fervent", "flamboyant", "flourish", "fortitude", "frugal", "futile",
    // G
    "galvanize", "garish", "garrulous", "grandiose", "gregarious", "guileless",
    // H
    "hamper", "haughty", "hedonism", "hypocrite",
    // I
    "iconoclast", "immutable", "impartial", "imperious", "implicit", "impulsive", "inane", "incongruous", "indolent", "infamous",
    "insolent", "intrepid", "irascible",
    // J
    "jubilant", "judicious",
    // K
    "kinetic",
    // L
    "laconic", "languish", "laudable", "lethargic", "lucid",
    // M
    "malicious", "malleable", "maverick", "meticulous", "mollify", "morose",
    // N
    "nefarious", "negligent", "nostalgic",
    // O
    "oblivious", "obsolete", "ominous", "opportunist", "ostracize",
    // P
    "paranoid", "patronize", "pedantic", "penitent", "pervasive", "pessimistic", "plausible", "pompous", "pragmatic", "presumptuous",
    "prevalent", "pretentious", "proficient", "prolific", "provocative",
    // Q
    "querulous",
    // R
    "rancid", "reckless", "redundant", "remorse", "resilient", "reticent", "ruthless",
    // S
    "sanction", "sarcastic", "satirical", "scandalous", "scrupulous", "shrewd", "sinister", "skeptical", "stoic", "superfluous",
    "surrender", "sycophant",
    // T
    "taciturn", "tenacious", "terse", "treacherous", "turbulent",
    // U
    "ubiquitous", "unscrupulous",
    // V
    "vacuous", "vehement", "venerate", "verbose", "vindictive", "virtuous",
    // W
    "wary", "wily", "wrath",
    // Z
    "zealous",
  ],

  // ── 9th Grade ──────────────────────────────
  // SAT preparatory vocabulary — full alphabet
  "9th": [
    // A
    "abase", "aberration", "abhor", "abject", "abnegate", "abscond", "abstain", "abstruse", "acerbic", "acrimonious",
    "acumen", "adamant", "admonish", "adroit", "adversary", "advocate", "aesthetic", "affable", "affluent", "aggregate",
    "alacrity", "alienate", "allegiance", "alleviate", "allusion", "altruistic", "ambiguous", "ameliorate", "amiable", "amicable",
    "anachronism", "anarchy", "anecdote", "anomaly", "antagonist", "apathy", "appease", "apprehensive", "archaic", "arduous",
    "articulate", "aspire", "assertion", "assumption", "atrocity", "audacious", "augment", "authentic", "avert", "axiom",
    // B
    "banal", "beguile", "belittle", "belligerent", "benevolent", "berate", "blatant", "bolster", "bombastic", "brazen",
    "brevity", "bureaucracy",
    // C
    "callous", "candid", "capricious", "catalyst", "caustic", "censure", "charlatan", "chronic", "circuitous", "circumvent",
    "coerce", "cogent", "compel", "complicit", "condescend", "convoluted", "copious", "credulous", "cryptic", "culpable",
    // D
    "daunt", "debilitate", "decorum", "defame", "deliberate", "delude", "denounce", "depravity", "deride", "despondent",
    "devious", "diatribe", "diffident", "diligent", "discern", "disparage", "dogmatic", "dubious", "duplicity",
    // E
    "eccentric", "egregious", "elusive", "empathy", "enigmatic", "erratic", "erudite", "euphemism", "exacerbate", "exonerate",
    "expedient", "explicit", "extraneous",
    // F
    "fallacious", "fastidious", "fervent", "flamboyant", "fortitude", "frugal", "futile",
    // G
    "galvanize", "garrulous", "grandiose", "gregarious",
    // H
    "haughty", "hedonism", "hypocrite", "hypothetical",
    // I
    "iconoclast", "immutable", "impartial", "imperious", "implicit", "impulsive", "inane", "incongruous", "indolent", "infamous",
    "insolent", "intrepid", "irascible", "irony",
    // J
    "jargon", "judicious",
    // K
    "kinetic",
    // L
    "laconic", "languish", "laudable", "lethargic", "lucid",
    // M
    "malicious", "malleable", "maverick", "meticulous", "mitigate", "mollify", "morose",
    // N
    "nefarious", "negligent", "nostalgic", "nuance",
    // O
    "oblivious", "obsolete", "ominous", "opportunist", "ostracize",
    // P
    "paranoid", "patronize", "pedantic", "penitent", "pervasive", "pessimistic", "plausible", "pompous", "pragmatic",
    "presumptuous", "pretentious", "proficient", "prolific", "provocative",
    // Q
    "querulous", "quixotic",
    // R
    "rancid", "reckless", "redundant", "remorse", "resilient", "reticent", "rhetoric", "ruthless",
    // S
    "sanction", "sarcastic", "satirical", "scandalous", "scrupulous", "shrewd", "sinister", "skeptical", "stoic", "subversive",
    "superfluous", "sycophant",
    // T
    "taciturn", "tenacious", "terse", "treacherous", "trivial", "turbulent",
    // U
    "ubiquitous", "unscrupulous",
    // V
    "vacuous", "vehement", "venerate", "verbose", "vindictive", "virtuous", "volatile",
    // W
    "wary", "wily", "wrath",
    // X
    "xenophobia",
    // Z
    "zealous",
  ],

  // ── 10th Grade ─────────────────────────────
  // SAT/ACT vocabulary
  "10th": [
    // A
    "abase", "aberration", "abeyance", "abjure", "abnegate", "abscond", "abstain", "abstruse", "acerbic", "acrimonious",
    "acumen", "adumbrate", "aesthetic", "alacrity", "alienation", "allegory", "alliteration", "altruism", "amalgamate", "ambivalence",
    "ameliorate", "anachronism", "anarchy", "anathema", "anomalous", "antithesis", "aphorism", "apocryphal", "apotheosis", "approbation",
    "archetype", "arduous", "aristocracy", "ascetic", "asperity", "assiduous", "assuage", "atrophy", "audacious", "auspicious",
    "avarice", "aversion", "axiom",
    // B
    "baroque", "bellicose", "belligerent", "bequeath", "bombastic", "byzantine",
    // C
    "cacophony", "capricious", "castigate", "catalyst", "caustic", "censure", "chicanery", "circumlocution", "circumspect", "clandestine",
    "cogent", "complacency", "conundrum", "copious", "corroborate", "culpable", "cynical",
    // D
    "dearth", "debauchery", "decadent", "deference", "denigrate", "denouement", "depravity", "despot", "diatribe", "didactic",
    "diffidence", "dissonance", "dogmatic", "duplicity",
    // E
    "ebullient", "egregious", "elegy", "elusive", "empirical", "enigmatic", "ephemeral", "equivocal", "erroneous", "erudite",
    "euphemism", "exacerbate", "exculpate", "exigent", "exorbitant",
    // F
    "fallacious", "fatuous", "fervent", "flagrant", "flippant", "fortitude", "fractious", "frugality",
    // G
    "garrulous", "grandiose", "gratuitous", "gregarious",
    // H
    "harangue", "hegemony", "heresy", "hubris", "hyperbole",
    // I
    "iconoclast", "idiosyncrasy", "ignominious", "immutable", "impetuous", "implacable", "imperious", "impunity", "inadvertent",
    "incendiary", "incorrigible", "indefatigable", "indignation", "ineffable", "ingenuous", "inimical", "insidious", "intransigent",
    // J
    "judicious", "juxtapose",
    // K
    "kindle",
    // L
    "laconic", "lampoon", "languish", "laud", "loquacious", "lucid", "ludicrous",
    // M
    "machiavellian", "magnanimous", "malevolent", "malleable", "mendacious", "mercurial", "misanthrope", "mitigate",
    // N
    "nefarious", "nihilism", "nostalgia", "nuance",
    // O
    "obdurate", "obsequious", "obstinate", "obtuse", "ominous", "ostentatious",
    // P
    "panegyric", "paradox", "pedantic", "perfidious", "pernicious", "petulant", "placate", "platitude", "plausible",
    "pompous", "pragmatic", "precarious", "predilection", "presuppose", "prevaricate", "prolific", "propitious", "provocative",
    // Q
    "querulous", "quixotic",
    // R
    "recalcitrant", "reclusive", "recondite", "redolent", "remorse", "reprehensible", "reticent", "rhetoric",
    // S
    "sacrosanct", "sanction", "sardonic", "scrupulous", "soliloquy", "sophistry", "spurious", "stoic", "subversive", "sycophant",
    // T
    "taciturn", "tendentious", "terse", "timorous", "tirade", "treacherous", "trite", "turbulent",
    // U
    "ubiquitous", "unequivocal", "untenable",
    // V
    "vacuous", "vehement", "venerate", "verbose", "vindictive", "vitriolic",
    // W
    "wanton", "wary", "wily",
    // X
    "xenophobia",
    // Z
    "zealous",
  ],

  // ── 11th Grade ─────────────────────────────
  // Advanced SAT/AP vocabulary
  "11th": [
    // A
    "abase", "aberration", "abeyance", "abjure", "abnegate", "abscond", "abstain", "abstruse", "acerbic", "acrimonious",
    "acumen", "adumbrate", "aesthetic", "alacrity", "alienation", "allegory", "alliteration", "altruism", "amalgamate", "ambivalence",
    "ameliorate", "anachronism", "anarchy", "anathema", "anomalous", "antithesis", "aphorism", "apocryphal", "apotheosis", "approbation",
    "archetype", "arduous", "aristocracy", "ascetic", "asperity", "assiduous", "assuage", "atrophy", "audacious", "auspicious",
    "avarice", "aversion", "axiom",
    // B
    "baroque", "bellicose", "bequeath", "bombastic", "byzantine", "bucolic",
    // C
    "cacophony", "capricious", "castigate", "catalyst", "caustic", "censure", "chicanery", "circumlocution", "clandestine",
    "cogent", "complacency", "conundrum", "copious", "corroborate", "culpable", "cynical", "contentious",
    // D
    "dearth", "debauchery", "decadent", "deference", "denigrate", "denouement", "depravity", "despot", "diatribe", "didactic",
    "diffidence", "dissonance", "dogmatic", "duplicity", "dystopia",
    // E
    "ebullient", "egregious", "elegy", "empirical", "enigmatic", "ephemeral", "equivocal", "erroneous", "erudite",
    "euphemism", "exacerbate", "exculpate", "exigent", "exorbitant", "existential",
    // F
    "fallacious", "fatuous", "fervent", "flagrant", "flippant", "fortitude", "fractious", "frugality", "furtive",
    // G
    "garrulous", "grandiose", "gratuitous", "gregarious", "guileless",
    // H
    "harangue", "hegemony", "heresy", "hubris", "hyperbole", "heuristic",
    // I
    "iconoclast", "idiosyncrasy", "ignominious", "immutable", "impetuous", "implacable", "imperious", "impunity",
    "incendiary", "incorrigible", "indefatigable", "indignation", "ineffable", "ingenuous", "inimical", "insidious", "intransigent",
    "irrefutable",
    // J
    "judicious", "juxtapose",
    // K
    "kinesthesia",
    // L
    "laconic", "lampoon", "languish", "laud", "loquacious", "lucid", "ludicrous",
    // M
    "machiavellian", "magnanimous", "malevolent", "malleable", "mendacious", "mercurial", "misanthrope", "mitigate", "myopic",
    // N
    "nefarious", "nihilism", "nostalgia", "nuance",
    // O
    "obdurate", "obsequious", "obstinate", "obtuse", "ominous", "ostentatious",
    // P
    "panegyric", "paradox", "pedantic", "perfidious", "pernicious", "petulant", "placate", "platitude", "plausible",
    "pompous", "pragmatic", "precarious", "predilection", "presuppose", "prevaricate", "prolific", "propitious", "provocative",
    "pyrrhic",
    // Q
    "querulous", "quixotic",
    // R
    "recalcitrant", "reclusive", "recondite", "redolent", "remorse", "reprehensible", "reticent", "rhetoric", "ruminate",
    // S
    "sacrosanct", "sanction", "sardonic", "scrupulous", "soliloquy", "sophistry", "spurious", "stoic", "subversive", "sycophant",
    "syzygy",
    // T
    "taciturn", "tendentious", "terse", "timorous", "tirade", "treacherous", "trite", "turbulent", "tautology",
    // U
    "ubiquitous", "unequivocal", "untenable", "utopian",
    // V
    "vacuous", "vehement", "venerate", "verbose", "vindictive", "vitriolic",
    // W
    "wanton", "wary", "wily",
    // X
    "xenophobia",
    // Z
    "zealous",
  ],

  // ── 12th Grade ─────────────────────────────
  // College-level / GRE vocabulary
  "12th": [
    // A
    "abase", "abeyance", "abjure", "abnegate", "abscond", "abstemious", "abstruse", "acerbic", "acrimonious", "acumen",
    "adumbrate", "aesthetic", "alacrity", "alienation", "allegory", "amalgamate", "ameliorate", "anachronism", "anathema", "anomalous",
    "antithetical", "apocryphal", "apotheosis", "approbation", "archetype", "arduous", "aristocracy", "ascetic", "asperity",
    "assiduous", "assuage", "atrophy", "audacious", "auspicious", "avarice", "axiom", "axiological",
    // B
    "baroque", "bellicose", "bequeath", "bombastic", "byzantine", "bucolic", "bathetic",
    // C
    "cacophony", "capricious", "castigate", "caustic", "censure", "chicanery", "circumlocution", "clandestine", "cogent",
    "complacency", "conundrum", "corroborate", "culpable", "cynical", "contentious", "cathexis",
    // D
    "dearth", "debauchery", "decadent", "deference", "denigrate", "denouement", "depravity", "despot", "diatribe", "didactic",
    "diffidence", "dissonance", "dogmatic", "duplicity", "dystopia", "dialectic",
    // E
    "ebullient", "egregious", "elegy", "empirical", "enigmatic", "ephemeral", "equivocal", "erroneous", "erudite",
    "euphemism", "exacerbate", "exculpate", "exigent", "exorbitant", "existential", "encomium",
    // F
    "fallacious", "fatuous", "fervent", "flagrant", "fortitude", "fractious", "frugality", "furtive", "fatalism",
    // G
    "garrulous", "grandiose", "gratuitous", "gregarious", "guileless", "gravitas",
    // H
    "harangue", "hegemony", "heresy", "hubris", "hyperbole", "heuristic", "hermeneutics",
    // I
    "iconoclast", "idiosyncrasy", "ignominious", "immutable", "impetuous", "implacable", "imperious", "impunity",
    "incendiary", "incorrigible", "indefatigable", "indignation", "ineffable", "ingenuous", "inimical", "insidious", "intransigent",
    "irrefutable", "inveterate",
    // J
    "judicious", "juxtapose",
    // K
    "kinesthesia",
    // L
    "laconic", "lampoon", "languish", "laud", "loquacious", "lucid", "ludicrous", "liminal",
    // M
    "machiavellian", "magnanimous", "malevolent", "malleable", "mendacious", "mercurial", "misanthrope", "mitigate", "myopic",
    "metaphysical",
    // N
    "nefarious", "nihilism", "nostalgia", "nuance", "nascent",
    // O
    "obdurate", "obsequious", "obstinate", "obtuse", "ominous", "ostentatious", "ontological",
    // P
    "panegyric", "paradox", "pedantic", "perfidious", "pernicious", "petulant", "placate", "platitude", "plausible",
    "pompous", "pragmatic", "precarious", "predilection", "presuppose", "prevaricate", "prolific", "propitious", "provocative",
    "pyrrhic", "polemic",
    // Q
    "querulous", "quixotic", "quotidian",
    // R
    "recalcitrant", "reclusive", "recondite", "redolent", "remorse", "reprehensible", "reticent", "rhetoric", "ruminate",
    "reductive",
    // S
    "sacrosanct", "sardonic", "scrupulous", "soliloquy", "sophistry", "spurious", "stoic", "subversive", "sycophant",
    "syzygy", "solipsism",
    // T
    "taciturn", "tendentious", "terse", "timorous", "tirade", "treacherous", "trite", "turbulent", "tautology", "teleological",
    // U
    "ubiquitous", "unequivocal", "untenable", "utopian",
    // V
    "vacuous", "vehement", "venerate", "verbose", "vindictive", "vitriolic", "verisimilitude",
    // W
    "wanton", "wary", "wily",
    // X
    "xenophobia",
    // Z
    "zealous",
  ],

};

// ─────────────────────────────────────────────
// HELPER FUNCTION
// Given a grade string like "3rd", returns
// the word list for that grade. Falls back
// to Kindergarten if the grade isn't found.
// ─────────────────────────────────────────────
export function getWordsForGrade(grade) {
  return SIGHT_WORDS[grade] || SIGHT_WORDS["K"];
}